import { CHAPTERS } from "../data/content";

export const ChapterProgress = ({ current }) => (
  <div
    data-testid="chapter-progress"
    className="glass fixed bottom-6 right-6 z-50 flex items-center gap-3 rounded-full px-5 py-3"
  >
    <span className="h-1.5 w-1.5 animate-pulse rounded-full bg-[#00BFA5]" />
    <span className="font-display text-xs font-bold tracking-[0.25em] text-[#0A192F]">
      {String(current).padStart(2, "0")} <span className="text-[#0A192F]/40">/ 11</span>
    </span>
    <span className="hidden text-[10px] font-semibold uppercase tracking-[0.18em] text-[#0A192F]/50 md:block">
      {CHAPTERS[current - 1]?.title}
    </span>
  </div>
);
